<template>
    <path fill-rule="evenodd" d="M17 5.777V1c0-.273-.218-1-1-1-.223 0-.443.074-.624.22l-2.658 2.125C11.384 3.412 9.708 4 8 4H2C.895 4 0 4.895 0 6v3c0 1.105.895 2 2 2l-.015 1c0 1.243.29 2.417.799 3.467.162.334.516.533.887.533h3.321c.815 0 1.303-.933.81-1.58-.513-.673-.817-1.511-.817-2.42 0-.347.05-.68.138-1H8c1.708 0 3.384.588 4.718 1.655l2.657 2.126c.178.141.398.219.625.219.778 0 1-.712 1-1V9.223c.595-.347 1-.984 1-1.723 0-.738-.405-1.376-1-1.723zM3.992 14.5c-.337-.795-.507-1.635-.507-2.5 0-.444.054-.792.081-1h2.029c-.066.334-.11.67-.11 1 0 .882.205 1.731.6 2.5H3.992zm3.508-5H2c-.276 0-.5-.224-.5-.5V6c0-.276.224-.5.5-.5h5.5v4zm8 3.46l-1.845-1.477c-1.337-1.07-2.962-1.73-4.655-1.92V5.437c1.693-.19 3.318-.85 4.655-1.92L15.5 2.04v10.918z"/>
</template>

<script>
export default {
    name: 'bullhornIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 18 16');
    }
}
</script>
